module.exports = __webpack_public_path__ + "img/asuransi-kesehatan.79b5a469.svg";